/* Isolated editorial galleries: no Elementor/jQuery dependency, no storefront side effects. */
(() => {
    // Existing custom elements are patched after this class is declared.
  class Editorial extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const template = this.querySelector('template[shadowrootmode]');
      if (!this.shadowRoot && template) {
        this.attachShadow({mode:'open'}).append(template.content.cloneNode(true));
        template.remove();
      }
      const root = this.shadowRoot;
      if (!root) return;
      this.initialized = true;
      root.querySelectorAll('.elementor-widget-image-carousel').forEach(widget => this.carousel(widget));
      this.lightbox(root);
      if (/^\/pages\/connector(?:$|-)/.test(window.location.pathname)) this.sortConnectorGalleries(root);
    }
    disconnectedCallback() { this.cleanup?.forEach(fn => fn()); this.initialized = false; }
    sortConnectorGalleries(root) {
      const galleries = [...root.querySelectorAll('.rey-gridEl')].concat([...root.querySelectorAll('p')].filter(paragraph => !paragraph.closest('.rey-gridEl') && paragraph.children.length > 1 && [...paragraph.children].every(child => child.matches('a') && child.querySelector('img'))));
      if (!galleries.length) return;
      this.cleanup ||= [];

      galleries.forEach(grid => {
                          const gallery = grid.querySelector('.__items') || grid, items = [...gallery.children].filter(item => (item.matches('.__item') || item.matches('a')) && item.querySelector('img'));
                          if (items.length < 2) return;

        const probeImage = item => new Promise(resolve => {
          const image = item.querySelector('img');
                  const source = image?.currentSrc || image?.src || item.querySelector('a[href]')?.href, width = Number(image?.getAttribute('width')) || image?.naturalWidth || 0, height = Number(image?.getAttribute('height')) || image?.naturalHeight || 0; if (width && height) return resolve({ item, width, height });
                        if (!source) return resolve({ item, width: 0, height: 0 });

          let probeUrl = source;
          try {
            const url = new URL(source, window.location.href);
            if (url.hostname.endsWith('shopify.com')) url.searchParams.set('width', '120');
            probeUrl = url.href;
          } catch {}

          const probe = new Image();
          const timeout = window.setTimeout(() => resolve({
            item,
            width: image?.naturalWidth || 0,
            height: image?.naturalHeight || 0
          }), 5000);
          const finish = () => {
            window.clearTimeout(timeout);
            resolve({ item, width: probe.naturalWidth, height: probe.naturalHeight });
          };
          probe.onload = finish;
          probe.onerror = () => {
            window.clearTimeout(timeout);
            resolve({ item, width: image?.naturalWidth || 0, height: image?.naturalHeight || 0 });
          };
          probe.src = probeUrl;
          if (probe.complete && probe.naturalWidth) finish();
        });

        Promise.all(items.map(probeImage)).then(images => {
          const portraits = [];
          const landscapes = [];

          images.forEach(({ item, width, height }) => {
            const image = item.querySelector('img');
            if (width && height && image) {
              const ratio = `${width} / ${height}`;
              image.style.setProperty('width', '100%', 'important');
              image.style.setProperty('height', 'auto', 'important');
              image.style.setProperty('aspect-ratio', ratio, 'important');
              image.style.setProperty('object-fit', 'contain', 'important');
              const link = image.closest('a.__media-link');
              if (link) {
                link.style.setProperty('height', 'auto', 'important');
                link.style.setProperty('aspect-ratio', ratio, 'important');
              }
            }
            (width && height && height > width ? portraits : landscapes).push(item);
          });

          if (!this.isConnected) return;

          const makeGroup = (name, groupItems) => {
            const group = document.createElement('div');
            group.className = `connector-gallery-group connector-gallery-group--${name}`;
            group.setAttribute('role', 'group');
            group.setAttribute('aria-label', `${name} images`);
            groupItems.forEach(item => group.append(item));
            return group;
          };

          const originalStyle = getComputedStyle(gallery);
          const originalTracks = originalStyle.gridTemplateColumns;
          const columnCount = originalTracks && originalTracks !== 'none'
            ? Math.max(1, originalTracks.trim().split(/\s+/).length)
            : 2;
          const columnGap = originalStyle.columnGap;
          const rowGap = originalStyle.rowGap;
          const portraitGroup = makeGroup('portrait', portraits);
          const landscapeGroup = makeGroup('landscape', landscapes);
          gallery.replaceChildren(portraitGroup, landscapeGroup);
                gallery.style.setProperty('display', 'flex', 'important');
                gallery.style.setProperty('flex-direction', 'column', 'important');
                      gallery.style.setProperty('row-gap', rowGap, 'important');
          [portraitGroup, landscapeGroup].forEach(group => {
            group.style.display = 'grid';
            group.style.width = '100%';
            group.style.gridTemplateColumns = `repeat(${columnCount}, minmax(0, 1fr))`;
            group.style.columnGap = columnGap;
            group.style.rowGap = rowGap;
            group.style.minWidth = '0';
          });
        });
      });
    }
    carousel(widget) {
      const scroller = widget.querySelector('.swiper');
      if (!scroller) return;
      scroller.classList.add('editorial-carousel','swiper-initialized');
      const track = scroller.querySelector('.swiper-wrapper');
      let settings = {}; try {settings = JSON.parse(widget.dataset.settings || '{}');} catch {}
      scroller.style.setProperty('--editorial-slides', settings.slides_to_show || 4);
      const previous = scroller.querySelector('.elementor-swiper-button-prev');
      const next = scroller.querySelector('.elementor-swiper-button-next');
      const move = direction => {
        const slide = track.querySelector('.swiper-slide');
        const distance = slide.getBoundingClientRect().width + 20;
        const max = track.scrollWidth - track.clientWidth;
        const desired = track.scrollLeft + distance * direction;
        track.scrollTo({left:desired > max + 2 ? 0 : desired < -2 ? max : desired, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      [previous,next].forEach((button,i) => {
        if (!button) return;
        button.innerHTML = i ? '<span aria-hidden="true">›</span>' : '<span aria-hidden="true">‹</span>';
        button.setAttribute('tabindex','0');button.setAttribute('role','button');
        button.setAttribute('aria-label',i?'Next image':'Previous image');
        button.addEventListener('click',()=>move(i?1:-1));
        button.addEventListener('keydown',event=>{if(['Enter',' '].includes(event.key)){event.preventDefault();move(i?1:-1);}});
      });
      let down, dragged=false;
      track.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'){down={x:e.clientX,left:track.scrollLeft};dragged=false;}});
      track.addEventListener('pointermove',e=>{if(down){let delta=e.clientX-down.x;if(Math.abs(delta)>6){dragged=true;track.style.scrollSnapType='none';track.scrollLeft=down.left-delta;e.preventDefault();}}});
      const release=()=>{down=null;track.style.scrollSnapType='';};
      window.addEventListener('pointerup',release);
      track.addEventListener('click',e=>{if(dragged){e.preventDefault();e.stopPropagation();dragged=false;}},true);
      const timer = settings.autoplay==='yes'&&!matchMedia('(prefers-reduced-motion: reduce)').matches ? setInterval(()=>{
        if(this.isConnected&&!scroller.matches(':hover')&&!down&&!document.hidden&&scroller.getBoundingClientRect().bottom>0&&scroller.getBoundingClientRect().top<innerHeight)move(1);
      },settings.autoplay_speed||5000):null;
      this.cleanup ||= [];this.cleanup.push(()=>{clearInterval(timer);window.removeEventListener('pointerup',release);});
    }
    lightbox(root) {
      const anchors = [...root.querySelectorAll('a[data-elementor-open-lightbox="yes"]')];
      if (!anchors.length) return;
      const dialog = document.createElement('dialog');
      dialog.className='editorial-lightbox';dialog.setAttribute('aria-label','Image gallery');
      dialog.innerHTML='<button class="editorial-close" aria-label="Close image gallery">×</button><button class="editorial-prev" aria-label="Previous image">‹</button><figure><img alt=""><figcaption aria-live="polite"></figcaption></figure><button class="editorial-next" aria-label="Next image">›</button>';
      root.append(dialog);
      let index=0, active=anchors, opener;
      const image=dialog.querySelector('img'), caption=dialog.querySelector('figcaption');
      const show=i=>{index=(i+active.length)%active.length;image.src=active[index].href;image.alt=active[index].querySelector('img')?.alt||'Jayda Hany';caption.textContent=`${index+1} / ${active.length}`;};
      const close=()=>{dialog.close();opener?.focus();};
      anchors.forEach(anchor=>anchor.addEventListener('click',event=>{
        event.preventDefault();opener=anchor;
        const gallery=anchor.closest('.rey-gridEl,.elementor-widget-image-carousel,.elementor-widget-image-gallery');
        active=gallery?[...gallery.querySelectorAll('a[data-elementor-open-lightbox="yes"]')]:anchors;
        show(active.indexOf(anchor));dialog.showModal();
      }));
      dialog.querySelector('.editorial-close').addEventListener('click',close);
      dialog.querySelector('.editorial-prev').addEventListener('click',()=>show(index-1));
      dialog.querySelector('.editorial-next').addEventListener('click',()=>show(index+1));
      dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
      dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight')show(index+1);if(event.key==='ArrowLeft')show(index-1);});
      let start;image.addEventListener('touchstart',e=>{start=e.changedTouches[0].clientX;},{passive:true});
      image.addEventListener('touchend',e=>{if(Math.abs(e.changedTouches[0].clientX-start)>40)show(index+(e.changedTouches[0].clientX<start?1:-1));},{passive:true});
    }
  }
  const ExistingEditorial = customElements.get('jayda-editorial');
if (ExistingEditorial) {
  ExistingEditorial.prototype.sortConnectorGalleries = Editorial.prototype.sortConnectorGalleries;
  if (/^\/pages\/connector(?:$|-)/.test(window.location.pathname)) {
    document.querySelectorAll('jayda-editorial').forEach(host => {
      if (host.shadowRoot) ExistingEditorial.prototype.sortConnectorGalleries.call(host, host.shadowRoot);
    });
  }
} else {
  customElements.define('jayda-editorial', Editorial);
}
})();
